import MainLayout from '../../components/Layouts/MainLayout/MainLayout';
import Hero from './Hero/Hero';
import ExplorationCard from '../../components/ExplorationCard/ExplorationCard';

const Home = () => {


	const explorations = [
		{
			title: 'Political Prediction Markets',
			points: [
				`Political prediction markets focused on high-interest political and policy developments across a wide range 
				of issues and jurisdictions.`,
				`A broader and deeper approach than other offerings, enabled by FiscalNote’s human policy expertise, expansive 
				datasets, and AI-driven analysis.`,
				`A differentiated user experience designed to support diverse questions, high-quality participation, and efficient, 
				 transparent market resolution.`
			],
			img: 'market'
		},
		{
			title: 'Political Prediction Leagues',
			points: [
				`Issue based leagues with multiple political prediction questions and two sponsor organizations representing 
				opposing sides of the issue.`,
				`Pay an entrance fee to join a league. Donate a portion of your trade value to one of the 
				 participating advocacy organizations. Earn points for each correct prediction to win.`,
				`Have fun while staying on top of issues that matter to you, and raise money and awareness for causes you 
				 believe in.`
			],
			img: 'league'
		},
		{
			title: 'AI and Expert Powered Prediction Engine',
			points: [
				`Get in-depth analysis of likely outcomes for upcoming political events, combining FiscalNote’s policy expertise 
				with AI-driven insights drawn from our global-to-local data sets.`,
				`Subscribe to get access to these predictions and other premium features.  Increase your odds of making the right 
				forecast wherever you place your predictions.`
			],
			img: 'engine'
		}
	];

	const explorationList = explorations.map(exp=> {return <ExplorationCard title={exp.title} points={exp.points} img={exp.img} key={exp.img}/>})

	return(
		<MainLayout>
			<Hero />
			<div className='col-12 col-md-10 offset-md-1 '>
				<h3 className='text-center mb-5' >Sign Up For Early Access</h3>
				{explorationList}
			</div>
		</MainLayout>
	)

}

export default Home;